export default "__VITE_ASSET__f17aad31__"